
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[params]/privacy-policy",
      function () {
        return require("private-next-pages/[params]/privacy-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[params]/privacy-policy"])
      });
    }
  